//Please add the language resource
const receivingAddress = {
  customerCode:'CustomerCode',
  skuCode:'SkuCode',
  skuNameZh: 'SkuNameZh',
  skuNameEn: 'SkuNameEn',
  skuDesc:'SkuDesc',
  skuType:'SkuType',
  length:'Length',
  width:'Width',
  height:'Height',
  volume: 'Volume',
  netWeight:'NetWeight',
  grossWeight:'GrossWeight',
  createTime:'CreateTime',
  creator:'Creator',
  updateTime:'UpdateTime',
  updater:'Updater',
  msg:{
  }
};
export default receivingAddress



// WEBPACK FOOTER //
// ./src/page/md/receivingAddress/lang/receivingAddress.en.js